const MEDIA_PARTNERS = [
  {
    id: "mp1",
    url: "https://customer-assets.emergentagent.com/job_elite-policy-summit/artifacts/7psmurnq_WhatsApp%20Image%202026-04-17%20at%206.34.16%20PM.jpeg",
    alt: "Media Partner 1",
  },
  {
    id: "mp2",
    url: "https://customer-assets.emergentagent.com/job_elite-policy-summit/artifacts/nikz5dn4_WhatsApp%20Image%202026-04-17%20at%206.34.16%20PM%20%282%29.jpeg",
    alt: "Media Partner 2",
  },
  {
    id: "mp3",
    url: "https://customer-assets.emergentagent.com/job_elite-policy-summit/artifacts/vb0h1t9n_WhatsApp%20Image%202026-04-17%20at%206.34.16%20PM%20%281%29.jpeg",
    alt: "Media Partner 3",
  },
  {
    id: "mp4",
    url: "https://customer-assets.emergentagent.com/job_elite-policy-summit/artifacts/y6b5n6x7_WhatsApp%20Image%202026-04-17%20at%206.34.15%20PM.jpeg",
    alt: "Media Partner 4",
  },
  {
    id: "mp5",
    url: "https://customer-assets.emergentagent.com/job_elite-policy-summit/artifacts/c04ikq6x_WhatsApp%20Image%202026-04-17%20at%206.34.15%20PM%20%281%29.jpeg",
    alt: "Media Partner 5",
  },
];

export default function MediaPartnersSection() {
  return (
    <section
      id="media-partners"
      data-testid="media-partners-section"
      style={{ background: "#080D1E" }}
      className="py-16 lg:py-20 px-6"
    >
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="overline-gold mb-3">Coverage &amp; Outreach</p>
          <h2 className="font-['Cormorant_Garamond'] text-3xl lg:text-4xl font-medium text-white">
            Media Partners
          </h2>
          <div className="gold-divider w-40 mx-auto mt-5" />
        </div>

        {/* Logo row */}
        <div className="flex flex-wrap items-center justify-center gap-8 lg:gap-12">
          {MEDIA_PARTNERS.map(({ id, url, alt }) => (
            <div
              key={id}
              data-testid={`media-partner-${id}`}
              className="group flex items-center justify-center bg-white/5 border border-[#D4AF37]/15 rounded-sm p-4 w-36 h-20 transition-all duration-300 hover:bg-white/10 hover:border-[#D4AF37]/40 hover:shadow-[0_0_20px_rgba(212,175,55,0.1)]"
            >
              <img
                src={url}
                alt={alt}
                className="max-h-12 max-w-full object-contain grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
